import { create } from 'zustand';

const INITIAL_STATE_FORM: IncomeProtectionForm.Form = {
  address: {
    city: '',
    complement: '',
    neighborhood: '',
    noComplement: false,
    noNumber: false,
    number: '',
    state: '',
    street: '',
    zipcode: '',
  },
  contact: { cellphone: '', email: '' },
  introduction: {
    acceptAccessionTerms: false,
    acceptGeneralConditions: false,
    document: '',
    fullName: '',
  },
  personalInfo: {
    birthDate: '',
    gender: null,
    maritalStatus: null,
  },
};

interface IncomeProtectionState {
  form: IncomeProtectionForm.Form;
  setIntroduction: (
    introductionForm: IncomeProtectionForm.Introduction
  ) => void;
  setPersonalInfo: (
    personalInfoForm: IncomeProtectionForm.PersonalInfo
  ) => void;
  setContact: (contactForm: IncomeProtectionForm.Contact) => void;
  setAddress: (addressForm: IncomeProtectionForm.Address) => void;
}

const updateForm = (
  state: IncomeProtectionState,
  field: keyof IncomeProtectionForm.Form,
  value: any
): IncomeProtectionState => {
  return {
    ...state,
    form: { ...(state.form || { ...INITIAL_STATE_FORM }), [field]: value },
  };
};

const useIncomeProtectionForm = create<IncomeProtectionState>((set) => ({
  form: {
    introduction: {} as IncomeProtectionForm.Introduction,
    personalInfo: {} as IncomeProtectionForm.PersonalInfo,
    contact: {} as IncomeProtectionForm.Contact,
    address: {} as IncomeProtectionForm.Address,
  },
  setIntroduction: (introduction) =>
    set((state) => updateForm(state, 'introduction', introduction)),
  setPersonalInfo: (personalInfo) =>
    set((state) => updateForm(state, 'personalInfo', personalInfo)),
  setContact: (contact) =>
    set((state) => updateForm(state, 'contact', contact)),
  setAddress: (address) =>
    set((state) => updateForm(state, 'address', address)),
}));

export default useIncomeProtectionForm;
